module.exports = __webpack_public_path__ + "static/media/ic_white_right_arrow.42b98338.svg";